import { render } from "./UserManagment.vue?vue&type=template&id=8a8baf36"
import script from "./UserManagment.vue?vue&type=script&lang=js"
export * from "./UserManagment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__